<template>
    <v-main>
        <div class="stepper-1">
            <div id="move-step1">
                <StepperBar
                    v-if="registrationFormDetail"
                    :stepOn="StepperType"
                    :stepper="1"
                />
            </div>
        </div>
        <FormData
            :step="step"
            :registrationFormDetail="registrationFormDetail"
            :student_id="student_id"
            v-if="registrationFormDetail && student_id"
            :registrationState="student_status"
            class="form-margin-top"
            @loadingUpdate="loadingUpdate"
        />
    </v-main>
</template>

<script>
import FormData from "./FormData";
import StepperBar from "./StepperBar";

export default {
    name: "StepOne",
    components: {
        FormData,
        StepperBar,
    },
    data: () => ({
        step: 1,
        email: null,
    }),
    props: {
        registrationFormDetail: Object,
        student_id: Number,
        student_status: String,
    },
    computed: {
        StepperType() {
            if (
                this.registrationFormDetail != null &&
                !(
                    this.registrationFormDetail?.fee == 0 ||
                    this.registrationFormDetail?.fee == null
                )
            )
                return true;
            else return false;
        },
    },
    methods: {
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },
    },
    mounted() {},
};
</script>
